import * as ACTION_TYPES from '../types';

let initialState = {
  warehouseList: [],
  warehouse: {},
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_WAREHOUSES:
      return { ...state, warehouseList: action.data };
    case ACTION_TYPES.REQUEST:
      return { ...state, loading: true };
    case ACTION_TYPES.DONE:
      return { ...state, loading: false };
    case ACTION_TYPES.RESET_WAREHOUSES:
      return { ...state, warehouseList: [] }
    case ACTION_TYPES.GET_WAREHOUSE_BY_ID:
      return { ...state, warehouse: action.data, loading: false }
    default:
      return state;
  }
};